import React from 'react';
import { bool, oneOfType, node, func } from 'prop-types';
import { CurrencySelectionModalEntry, LanguageSelectionModalEntry, STYLES } from '@fiverr-private/locale_settings';
import Nav from '../../../lib/Nav';
import LanguageLink from '../LanguageLink';
import CurrencyLink from '../CurrencyLink';

const MenuLocaleSettingsLink = ({ showCurrency = true, ItemWrapper = Nav.PopoverItem }) => (
    <>
        <ItemWrapper>
            <LanguageLink style={STYLES.MENU} Component={LanguageSelectionModalEntry} />
        </ItemWrapper>
        {showCurrency && (
            <ItemWrapper>
                <CurrencyLink style={STYLES.MENU} Component={CurrencySelectionModalEntry} />
            </ItemWrapper>
        )}
    </>
);

MenuLocaleSettingsLink.propTypes = {
    showCurrency: bool,
    ItemWrapper: oneOfType([func, node]),
};

export default MenuLocaleSettingsLink;
